var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginPageLayoutCard',[_c('ForgotCardHeader'),_c('ForgotCardForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }